/* eslint-disable no-unused-vars */

import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import _ from 'lodash';

import SiteListingInner from '@components/site-listing-inner';
import Textarea from '@components/textarea';
import MapField from './map-field';
import VesselsContainer from './vessels-container';
import PSVsContainer from './psvs-container';
import MoreInfoContainer from './more-info-container';

import style from './style.module.scss';

const BodyContainer = ({
  siteDetail,
  errors,
  register,
  watch,
  getValues,
  control,
  setValue,
  formFields,
  moreInfoFormFields,
  moreInfoOfVessel,
  moreInfoOfPSVs,
  isVesselVersion,
  isPSVVersion,
  setOpenAddPsvModalEvent,
  newEquipmentId,
  openAttachOrReattachModalEvent,
  setOpenAddFieldModalEvent,
  attachAndDeAttach = [],
  equipmentEditingStatus = '',
  commentForReviewer,
  setCommentForReviewer,
  isNewEquipment = false
}) => {
  const navigate = useNavigate();
  const onClickOpliiDesktopLinkEvent = (link) => {
    // window.open(link, '_blank');
    navigate(link);
  };
  const isInputReconcile = useCallback(
    ({ fieldName, isMasterData, isNumber = false }) => {
      let val = isNumber && watch(fieldName) ? Number(watch(fieldName)) : watch(fieldName);
      const reconcileValue =
        isNumber && watch(`${fieldName}-reconcile`)
          ? Number(watch(`${fieldName}-reconcile`))
          : watch(`${fieldName}-reconcile`);

      let numCond = reconcileValue > 0;
      let strCond = !_.isEmpty(watch(`${fieldName}-reconcile`));

      let emptyValueCond = isNumber ? numCond : strCond;

      return emptyValueCond
        ? isMasterData && reconcileValue !== val
          ? true
          : false
        : !_.isEmpty(watch(fieldName)) && isMasterData;
    },
    [watch]
  );

  const isSelectBoxReconcile = useCallback(
    ({ fieldName, isMasterData, options }) => {
      return !_.isEmpty(watch(`${fieldName}-reconcile`))
        ? isMasterData &&
          options?.length > 0 &&
          watch(`${fieldName}-reconcile`) !== watch(fieldName)
          ? true
          : false
        : !_.isEmpty(watch(fieldName)) && options?.length > 0 && isMasterData;
    },
    [watch]
  );
  const isTextBoxUnitReconcile = useCallback(
    ({ fieldName, isMasterData }) => {
      return !_.isEmpty(watch(`${fieldName}-reconcile.textBoxUnitValue`))
        ? !_.isNull(watch(`${fieldName}-reconcile.textBoxValue`)) &&
          isMasterData &&
          watch(`${fieldName}.textBoxValue`)?.toString() !==
            watch(`${fieldName}-reconcile.textBoxValue`)?.toString()
          ? true
          : watch(`${fieldName}.textBoxUnitValue`) !==
            watch(`${fieldName}-reconcile.textBoxUnitValue`)
          ? true
          : false
        : !_.isNull(watch(`${fieldName}.textBoxValue`)) &&
            !_.isEmpty(watch(`${fieldName}.textBoxUnitValue`)) &&
            isMasterData;
    },
    [watch]
  );

  return (
    <div className={style.content_body} id="add-edit-equipment-body">
      <div>
        {siteDetail?.map((data, index) => (
          <SiteListingInner
            appliesTo
            normal
            {...data}
            onSelect
            showCheckInIcon
            hideLocation={true}
            showChevronIcon={false}
            key={data.siteId || index}
            moreInfo={true}
            siteDetails
            showWOCount
            noLink={true}
          />
        ))}

        {equipmentEditingStatus && attachAndDeAttach?.length > 0 && isPSVVersion && (
          <div>
            <div className={`${style.divider} ${style.borderTopNone} `}>
              <p>Suggested relationship changes</p>
            </div>

            <VesselsContainer
              vesselInfo={false}
              attached={attachAndDeAttach?.filter((x) => x?.verificationStatus === 'attached to')}
              deAttached={attachAndDeAttach?.filter((x) => x?.verificationStatus !== 'attached to')}
            />
          </div>
        )}

        <div className={style.commentForReviewer}>
          <Textarea
            value={commentForReviewer}
            dot={false}
            label={'Comments (for reviewer)'}
            inputClass="input-field input-regular"
            labelColor={style.labelColor}
            {...(isNewEquipment ? { register: register } : {})}
            name={'commentForReviewer'}
            error={errors['commentForReviewer']?.message ? 'Required' : ''}
            isRequiredMsg={'Required'}
            reconciled={false}
            showReconciled={false}
            {...(!isNewEquipment
              ? {
                  onChange: (event) => {
                    setCommentForReviewer(event.target.value);
                  }
                }
              : {})}
          />
        </div>
      </div>
      <div className={style.formFields}>
        {formFields?.map((field, index) => {
          return (
            <div
              className={index === formFields?.length - 1 ? '' : style['mb-16']}
              key={field?.order}
              style={{
                marginTop: '16px'
              }}
            >
              {field?.grid2 ? (
                <div className={style.grid2}>
                  {field?.fields?.map((x, index) => {
                    return (
                      <MapField
                        key={index}
                        field={x}
                        isInputReconcile={isInputReconcile}
                        isSelectBoxReconcile={isSelectBoxReconcile}
                        isTextBoxUnitReconcile={isTextBoxUnitReconcile}
                        errors={errors}
                        register={register}
                        watch={watch}
                        getValues={getValues}
                        control={control}
                        setValue={setValue}
                        showReconcileFeatherIconWhenValueChanged
                        moreInfoOfPSVs={moreInfoOfPSVs}
                      />
                    );
                  })}
                </div>
              ) : (
                <MapField
                  field={field}
                  isInputReconcile={isInputReconcile}
                  isSelectBoxReconcile={isSelectBoxReconcile}
                  isTextBoxUnitReconcile={isTextBoxUnitReconcile}
                  errors={errors}
                  register={register}
                  watch={watch}
                  getValues={getValues}
                  control={control}
                  setValue={setValue}
                  showReconcileFeatherIconWhenValueChanged
                  moreInfoOfPSVs={moreInfoOfPSVs}
                />
              )}
            </div>
          );
        })}
      </div>

      {moreInfoOfVessel?.length > 0 || isPSVVersion || isVesselVersion ? (
        <div className={style.divider}>
          <p>Attached</p>
        </div>
      ) : (
        <></>
      )}

      {moreInfoOfVessel?.length > 0 || isPSVVersion ? (
        <VesselsContainer moreInfoOfVessel={moreInfoOfVessel} />
      ) : (
        <></>
      )}
      {isVesselVersion && (
        <PSVsContainer
          moreInfoOfPSVs={moreInfoOfPSVs}
          errors={errors}
          setOpenAddPsvModalEvent={setOpenAddPsvModalEvent}
          vesselEquipmentId={watch('equipmentId') || newEquipmentId}
          openAttachOrReattachModalEvent={openAttachOrReattachModalEvent}
          onClickOpliiDesktopLinkEvent={onClickOpliiDesktopLinkEvent}
        />
      )}

      <MoreInfoContainer
        setOpenAddFieldModalEvent={setOpenAddFieldModalEvent}
        moreInfoFormFields={moreInfoFormFields}
        errors={errors}
        register={register}
        watch={watch}
        getValues={getValues}
        control={control}
        setValue={setValue}
        isInputReconcile={isInputReconcile}
        isSelectBoxReconcile={isSelectBoxReconcile}
        isTextBoxUnitReconcile={isTextBoxUnitReconcile}
      />
    </div>
  );
};

export default BodyContainer;
